import React from 'react'

const VirtualClassrooms = () => {
  return (
    <div>VirtualClassroom</div>
  )
}

export default VirtualClassrooms